import React from 'react';
import { Label } from '../../../common/Label';

interface FieldProps {
  id: string;
  label: string;
  error?: string;
  required?: boolean;
  hint?: string;
  children: React.ReactNode;
}

export const Field: React.FC<FieldProps> = ({
  id,
  label,
  error,
  required,
  hint,
  children,
}) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="flex items-center gap-1">
      {label}
      {required && (
        <span aria-hidden className="text-red-500">
          *
        </span>
      )}
    </Label>
    {children}
    {hint && !error && (
      <p className="text-xs text-title-page-color-300/80 dark:text-gray-500">
        {hint}
      </p>
    )}
    {error && <p className="text-xs font-medium text-red-500">{error}</p>}
  </div>
);
